import { render, staticRenderFns } from "./CustomFieldsDraggableBox.vue?vue&type=template&id=5eb014fb&"
import script from "./CustomFieldsDraggableBox.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsDraggableBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports